import React from 'react';
import iconSizes from 'constants/iconSizes.js';

const ProductsIcon = ({ color = '#000', size = 'm24', ...attr }) => {
  return (
    <svg {...iconSizes[size]} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...attr}>
      <title>Products Icon</title>
      <path d="M5 5H10V10H5V5Z" stroke={color} strokeWidth="2" />
      <path d="M5 14H10V19H5V14Z" stroke={color} strokeWidth="2" />
      <path d="M14 5H19V10H14V5Z" stroke={color} strokeWidth="2" />
      <path
        d="M19 16.5C19 17.8807 17.8807 19 16.5 19C15.1193 19 14 17.8807 14 16.5C14 15.1193 15.1193 14 16.5 14C17.8807 14 19 15.1193 19 16.5Z"
        stroke={color}
        strokeWidth="2"
      />
    </svg>
  );
};

export default ProductsIcon;
